/** A schema to describe the Affiliation slice. */
export const FacetSearchAffiliatedWithSlice = {
  selected: null,
  orgListRefs: {}
}
